/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ApiStatusResponseType } from '@/types/Profile/ApiStatusResponseType';
import { RESPONSEMESSAGE } from '@/utils/constants';

export interface IResponseMessageState {
  messages: ApiStatusResponseType;
}

const initialState: IResponseMessageState = {
  messages: {} as ApiStatusResponseType,
};

export const responseMessageSlice = createSlice({
  name: RESPONSEMESSAGE,
  initialState,
  reducers: {
    setResponseMessage: (
      state,
      { payload }: PayloadAction<ApiStatusResponseType>
    ) => {
      state.messages = payload;
    },
  },
});

export const { setResponseMessage } = responseMessageSlice.actions;

export const responseMessageReducer = responseMessageSlice.reducer;
